import { Organization } from './';

// Org + Awards
import { AWARDS } from '../awards/list';

//
var AwardsSchema = Organization;
AwardsSchema['awards'] = '';
AwardsSchema['awards'] += AWARDS.map((year, key) => {
  {
    return year.awards.map((item, key) => {
      return item.name;
    });
  }
});
export const Awards = AwardsSchema;
